import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { DataService } from '../data.service';
import { HomeComponent } from '../home/home.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {environment} from '../../environments/environment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CalDiscount } from './../my-date.pipe';
import { local } from 'angular-io-datepicker';

declare var $: any;
declare var fbq: any;
declare var System:any;

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css'],
  providers: [ CalDiscount ]
})
export class PricingComponent implements OnInit, AfterViewInit {
  planData: any[] = [];
  couponApplied: boolean = false;
  checkoutready:boolean = false;
  selectedPlanId: number = -1;
  amount: number = 0;
  netAmount: number = 0;
  appliedDiscount: number = 0;
  couponId: number = -1;
  userId: number = -1;
  planId: number = -1;
  planId2: number = -1;
  userTypeId: number = -1;
  isNext: boolean = false;
  signUpModal: boolean = false;
  signupForm: FormGroup;
  userModal: boolean = false;
  userType: string = "New Account";
  users: any[] = [];
  userName:string='';
  selected:string='';
  isExist:boolean=false;
  user:PricingUser;
  noOfClicks:number=0;
  emailModal:boolean =false;
  add_another_Modal:boolean =false;
  emailForm:FormGroup;
  previousPlanId:number=0;
  emailUser:number=0;
  paymentUrl = environment.paymentUrl;
  isPaymentReady : boolean = false;
  confirmModal : boolean = false;
  isLoading:boolean=false;
  isUserLoggedIn:boolean=false;
  paramDiscount: any;
  currentUrl: any;

  constructor(private service: DataService, private el: ElementRef, private home: HomeComponent, private fb: FormBuilder, private router: Router, public route: ActivatedRoute, public calDiscount: CalDiscount) {
    this.userId = localStorage.getItem("UserId") == null ? -1 : parseInt(localStorage.getItem("UserId"));
    this.userTypeId = localStorage.getItem("UserTypeId") == null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId = localStorage.getItem("planId") == null ? -1 : parseInt(localStorage.getItem("planId"));
    this.readyForm('');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;        
      }
    });  
  }

  

  readyForm(mail) {
    //  localStorage.setItem("UserEmail", form.value['email']);
    // localStorage.getItem("mail")
    
    // this.emailUser = parseInt(localStorage.getItem('UserId'));
    this.emailForm = this.fb.group({
      
      'mail':localStorage.getItem('UserEmail')
    })
  }

  readySignupForm(email){
    this.signupForm = this.fb.group(
      {
        'fname': ['', Validators.required],
        'lname': ['', Validators.required],
        'phno': ['', Validators.compose([Validators.required, Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])],
        'email': [email, Validators.compose([Validators.required, Validators.email])]
      });
  }

  ngOnInit() {
  
    // fbq.disablePushState = true;
    // fbq('track','ViewContent');
    //this.checkoutready=false;
    fbq('trackCustom','virtualPageView',{
      url: 'https://stratgist.com/landingpage' + this.currentUrl
    })
    
    if (sessionStorage.getItem('from-payment') != null) {
      sessionStorage.removeItem('from-payment');
    }
    this.getPlan();
    this.createUserType();
    // fbq('track', 'CompleteRegistration');
    if(this.currentUrl == "/pricing-25")
     {     
       environment.footer40=false;
      this.paramDiscount = 25;

    } else {     
      //alert('hh'+environment.footer40)
       environment.footer40=true;
      this.paramDiscount = 40;
      
    }
    localStorage.setItem('discount', this.paramDiscount);
  }

  ngAfterViewInit() {

    $(window).scrollTop(0);
    $('.cd-header').css('background-color', '#931346');

  }

  getPlan() {
    this.service.GetPlanV2()
      .subscribe(
        (result: any[]) => {
          if (result['Status'] == "Success") {
            this.planData = result['PlanData'];
          } else {
            this.service.alertMessage(result['Message'], 'error');
          }
        },
        (error) => {
          // console.log(error);
        }
      )
  }

  applyCoupon(pvarId, pvarAmount, size) {
    this.couponId = -1;
    this.couponApplied = false;
    this.netAmount = 0;
    if (size == "lg") {
      this.el.nativeElement = document.querySelector('#couponValueLg' + pvarId);
    } else {
      this.el.nativeElement = document.querySelector('#couponValueSm' + pvarId);
    }

    // console.log(this.el.nativeElement.value);
    let value = this.el.nativeElement.value;
    this.selectedPlanId = pvarId;
    this.previousPlanId =  this.selectedPlanId;
    const inputJson = {
      "CouponCode": value
    }
    if (value == null || value == "") {
      this.service.alert('Please enter coupon code', 'error');
      return false
    } else {
      this.service.applyCoupon(inputJson)
        .subscribe(
          (result: any[]) => {
            if (result['Status'] == "Success") {
              this.couponApplied = true;
              this.calcNetAmount(result['Amount'], pvarAmount, result['CouponId']);
            } else {
              this.service.alertMessage(result['Message'], 'error');
              this.couponApplied = false;
            }
          },
          (error) => {
            // console.log(error);
          }
        )
    }
  }

  removeBlurness(pvarId) {
    this.selectedPlanId = pvarId;
    this.couponApplied = false;
  }

  calcNetAmount(discount, amount: number, couponId) {    
      this.amount = +this.calDiscount.transform(amount);
      this.couponId = couponId;
      this.appliedDiscount = (discount * this.amount) / 100;
      this.netAmount = this.amount - this.appliedDiscount;
  }
  plan_id_get(id)
  {
   
   // alert(id)
    if (id == 2) {
     this.selected = "Quarterly"
    }
    else if (id == 3) {
      this.selected = "Annual"
    }
    else if (id == 6) {
      this.selected = "Lifetime"
    }
    
    this.add_another_Modal = true
    //alert(message)
  }
  conferm_new_plan(emailForm){
    this.add_another_Modal = false
    this.checkEmailExist(emailForm)
   // this.emailModal = true;
  }
  buyNow(planId, amount, totalAmount) {
    debugger;
    if(!this.checkoutready){
      this.appliedDiscount = +(( this.paramDiscount *amount) / 100);
      amount = +(amount - this.appliedDiscount);
    }
   
     

    // console.log(this.isPaymentReady);
    // console.log(totalAmount);
    // console.log(amount);
    let calc_total_amount:number=totalAmount;
    let calc_coupon_id:number=this.couponId;
      if(calc_coupon_id!=-1 && this.previousPlanId!=planId){
        calc_total_amount=amount;
        calc_coupon_id=-1;
        this.removeBlurness(planId);
      }
      if(calc_coupon_id!=-1 && this.previousPlanId==planId){
        if(this.couponApplied==false){
          calc_total_amount=amount;
          calc_coupon_id=-1;
        }
      }

    const _successUrl = "https://stratgist.com/landingpage/thanks";
    const _failureUrl = "https://stratgist.com/landingpage";

    let inputJson = {};
    this.planId2=parseInt(localStorage.getItem("planId"));
    if (this.userId != -1) {
      this.user = new PricingUser(planId, amount, calc_total_amount,calc_coupon_id);
      if(this.isPaymentReady == false){
       // alert(JSON.stringify(this.user))
      
        if(this.planId2==-1){
          this.emailModal = true;
        }
        else{
          this.plan_id_get(this.planId2)
//alert('else')
        }
        if(sessionStorage.getItem('UserEmail')!=null){
          this.readyForm(sessionStorage.getItem('UserEmail'));
        }

      } else {

        if (totalAmount == 0 && this.couponId == -1) {
          inputJson = {
            "Amount": amount,
            "CouponId": -1,
            "FailureUrl": _failureUrl,
            "PlanId": planId,
            "SuccessUrl": _successUrl,
            "UserId": localStorage.getItem("UserId") == null ? -1 : parseInt(localStorage.getItem("UserId"))
          }

        } if (totalAmount != 0 && this.couponId != -1 && planId == this.previousPlanId) {

          inputJson = {
            "Amount": totalAmount,
            "CouponId": this.couponId,
            "FailureUrl": _failureUrl,
            "PlanId": planId,
            "SuccessUrl": _successUrl,
            "UserId": localStorage.getItem("UserId") == null ? -1 : parseInt(localStorage.getItem("UserId"))
          }
        }
        if (totalAmount != 0 && this.couponId != -1 && planId != this.previousPlanId) {

          inputJson = {
            "Amount": amount,
            "CouponId": -1,
            "FailureUrl": _failureUrl,
            "PlanId": planId,
            "SuccessUrl": _successUrl,
            "UserId": localStorage.getItem("UserId") == null ? -1 : parseInt(localStorage.getItem("UserId"))
          }
        }
        // console.log(inputJson);
        this.service.PaymentForModule(inputJson)
          .subscribe(
            (response) => {              
              if (response['Status'] == "Success") {
                fbq('track', 'InitiateCheckout');              
                localStorage.setItem('isLoading','false');
                location.href = this.paymentUrl + response['Id'];
              } else {
                this.service.alert(response['Message'], "error");
              }
            },
            (error) => {
              this.service.alert(error, 'error');
            }
          )
      }
    } else {
      this.user = new PricingUser(planId, amount, calc_total_amount,calc_coupon_id);
      if(this.isPaymentReady == false){
        this.emailModal=true;
        this.readyForm('');
      }else {
        this.checkoutready=false;
        this.buyNow(this.user.planId,this.user.amount,this.user.totalAmount);
      }
    }

    this.checkoutready=false;
  }

  showActiveModule(pvarChoice) {
    this.home.showActiveModule(pvarChoice);
  }

  showSignupModal() {
    this.signUpModal = true;
    this.readyForm('');
  }

  addUserFromPaymentPage(form: FormGroup) {
    this.isLoading = true;
    this.noOfClicks+=1;
    // sessionStorage.setItem('from-payment','true');
    let inputJson = {};
    this.emailUser = parseInt(localStorage.getItem('UserId'));
    if(this.emailUser==-1){
      inputJson = {

       "Amount":this.user.totalAmount==0 ? this.user.amount : this.user.totalAmount,
       "CoupanId":this.user.couponId,
       "EmailID":form.value['email'],
       "FirstName":form.value['fname'],
       "LastName":form.value['lname'],
       "MobileNo":form.value['phno'],
       "PlanId":this.user.planId,
       "UserId":-1,
       // "IsLocal":true,

     }
   } else {
     if(this.isUserLoggedIn==true){
       inputJson = {

        "Amount":this.user.totalAmount==0 ? this.user.amount : this.user.totalAmount,
        "CoupanId":this.user.couponId,
        "EmailID":form.value['email'],
        "FirstName":form.value['fname'],
        "LastName":form.value['lname'],
        "MobileNo":form.value['phno'],
        "PlanId":this.user.planId,
        "UserId":-1,
        // "IsLocal":true,

      }
    } else {
      inputJson = {
            "Amount":this.user.totalAmount==0 ? this.user.amount : this.user.totalAmount,
            "CoupanId":this.user.couponId,
            "EmailID":'',
            "FirstName":'',
            "LastName":'',
            "MobileNo":'',
            "PlanId":this.user.planId,
            "UserId":-1,
            // "IsLocal":true,

          }
    }

        }

    console.log(inputJson);
    if(form.valid && this.noOfClicks==1){
        this.service.AddUserFromlandingPaymentPage(inputJson).subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              fbq('track', 'InitiateCheckout');
              this.isLoading = false;
              this.noOfClicks=0;
              this.signUpModal = false;
              let enableLogin:boolean = sessionStorage.getItem('EnableLogin')=='false' ? false : true;
              if(enableLogin){
                sessionStorage.setItem("UserEmail",form.value['email']);
                sessionStorage.setItem("UserPass",result['Name']);
                  sessionStorage.setItem("from-payment",'true');
                  this.userId=result['UserId'];
                  localStorage.setItem('UserId',this.userId.toString());

              } else {

              }
                    this.service.storageSub.next('change');
                    this.isPaymentReady = true;

                    localStorage.setItem('isLoading','false');
                      location.href = this.paymentUrl + result['Id'];
                      this.checkoutready=false;
                    this.buyNow(this.user.planId,inputJson['Amount'],this.user.totalAmount);

            } else {
              this.isLoading = false;
              this.noOfClicks=0;
              this.service.alert(result['Message'],'error')
            }
          },
          (error)=>{
            this.isLoading = false;
            this.noOfClicks=0;
            console.log(error);
          }
        )
    } else {
      this.noOfClicks = 0;
    }
  }

  checkUserExist() {
    this.userModal = true;
  }

  checkEmailExist(form:FormGroup){
     debugger;
    this.checkoutready=false;
    if(form.valid){
      const inputJson = {
        "Amount":this.user.couponId==-1 ? this.user.amount : this.user.totalAmount,
      	"CoupanId":this.user.couponId,
      	"EmailID":form.value['mail'],
      	"PlanId":this.user.planId
      }
      console.log(inputJson);
      this.service.CheckEmail(inputJson).subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            debugger
            let email_user_id=result['Id'];
            this.emailUser=email_user_id;
            // this.userId = email_user_id;

            let usertypeId=result['UserTypeId'];

            if(email_user_id==-1){ // User not logged in and email does not exist
              if(this.userId==-1){
                localStorage.setItem('UserId',email_user_id);
                this.emailModal=false;
                sessionStorage.setItem('EnableLogin','true');
                // this.confirmModal = true;
                this.showSignupModal();
                this.readySignupForm(form.value['mail']);
              }else {//User logged in and email does not exist
                this.emailModal=false;
                this.confirmModal = true;
                
                sessionStorage.setItem('EnableLogin','false');
                // localStorage.setItem('UserId','-1');
                this.isUserLoggedIn=true;
                this.readySignupForm(form.value['mail']);

              }
            }
            else if(usertypeId==3||usertypeId==4){
              this.service.alert('You already have a corporate account.Please get in touch with your point of contact!','error');
              return false;
            }
            else if(email_user_id!=-1){ // Email already exists
             this.userId = email_user_id;
              localStorage.setItem('UserId',this.userId.toString());
              this.emailModal=false;
              this.isPaymentReady = true;
              this.checkoutready=true;
              this.buyNow(this.user.planId,this.user.amount,this.user.totalAmount);
            }
          }
        },
        (error)=>{
          console.log(error);
        }
      )
    }
  }

  createUserType() {

    this.users = [{"userType":"New Account"},
    {"userType":"Existing Account"}
  ];

    console.log(this.users);

  }

  validateUserType() {
    debugger;
    if (this.userType == "New Account") {
      this.userModal = false;
      this.showSignupModal();
    } else {
      sessionStorage.setItem('from-payment', 'true')
      this.router.navigate(['/login'])
    }
  }

  getSelectedUserType() {
    console.log(this.userType);
  }


}

class PricingUser {
  planId:number=-1;
  amount:number=0;
  totalAmount:number=0;
  couponId:number=-1;

  constructor(planId:number,amount:number,totalAmount:number,couponId:number) {
  this.planId=planId;
  this.amount=amount;
  this.totalAmount=totalAmount;
  this.couponId=couponId;
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/pricing/pricing.component.ts